import React from "react";
import { Camera2 } from "react-bootstrap-icons";

function Choice({ choice, onUpdate, type }) {
  const setChoiceText = (e) => {
    choice.text = e.target.value;
    onUpdate(choice);
  };

  return (
    <li className="my-2">
      <div className="form-check">
        {type === "CHECK" && (
          <input type="checkbox" className="form-check-input" />
        )}
        {type === "RADIO" && (
          <input type="radio" className="form-check-input" />
        )}
        {type !== "PHOTO" ? (
          <input
            type="text"
            className="form-control"
            defaultValue={choice.text}
            onChange={setChoiceText}
          />
        ) : (
          <Camera2 size={25} />
        )}
      </div>
    </li>
  );
}

export default Choice;
